module.exports = __webpack_public_path__ + "static/media/drums.81dd2192.mp3";